<template>
  <el-row :gutter="16" v-loading="pending == null || existing == null || inventory == null">
    <el-col :xs="24" :sm="10" :style="$mq != 'xs' ? 'border-right: 1px solid #dedede;' : ''">
      <h5>Pending</h5>
      <el-table
        v-if="pending != null && inventory != null"
        :height="windowHeight - 200"
        :data="pending">
        <el-table-column
          label="Item"
          sortable
          min-width="150">
          <template slot-scope="scope">
            <span>{{inventory.find(l => scope.row.request.item_id == l.o_id).item_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Requestor"
          sortable
          prop="requestor.lastName"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>{{getFullName(users.find(c => scope.row.request.user_id == c.o_id))}}</span>
          </template>
        </el-table-column>
        <el-table-column
            :fixed="$mq === 'xs' ? false : 'right'"
            min-width="120"
            align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button @click="approveApproval(scope.row)" icon="el-icon-check" type="success" size="small"></el-button>
              <el-button @click="dismissApproval(scope.row)" icon="el-icon-close" type="danger" size="small"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table> 
    </el-col>
    <el-col :xs="24" :sm="14">
      <div style="display: flex;">
        <h5 class="mgra">Existing</h5>
        <el-popover
            placement="top"
            width="300"
            v-model="reqVisible"
            trigger="click">

          <el-select
            v-model="preapp.item_id"
            style="width: 100%; margin-bottom: 8px;"
            filterable
            remote
            reserve-keyword
            :remote-method="iremoteMethod"
            :loading="iReqLoading"
            placeholder="Item...">
            <el-option
            v-for="item in iSearchList"
            :key="item.o_id"
            :label="item.item_name"
            :value="item.o_id">
            </el-option>
          </el-select>
          <el-select
            v-model="preapp.requestor_id"
            style="width: 100%"
            filterable
            remote
            reserve-keyword
            :remote-method="cRemoteMethod"
            :loading="cReqLoading"
            placeholder="User...">
            <el-option
            v-for="item in cSearchList"
            :key="item.o_id"
            :label="getFullName(item)"
            :value="item.o_id">
            </el-option>
          </el-select>

          <hr style="margin: 16px; margin-top: 8px;"/>

          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="reqVisible = false">Cancel</el-button>
            <el-button type="primary" size="mini" :disabled="preapp.requestor_id == null || preapp.item_id == null" @click="preapprove">Submit</el-button>
          </div>
          <el-button slot="reference" type="text" size="small">Pre-Approve</el-button>

        </el-popover>
      </div>
      <el-table
        v-if="existing != null && inventory != null"
        :height="windowHeight - 200"
        :data="existing">
        <el-table-column
          label="Item"
          sortable
          prop="item.item_name"
          min-width="150">
        </el-table-column>
        <el-table-column
          label="Requestor"
          sortable
          prop="requestor.lastName"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>{{getFullName(scope.row.requestor)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="Approver"
          prop="approver.lastName"
          min-width="150">
          <template slot-scope="scope">
            <span>{{getFullName(scope.row.approver)}}</span>
          </template>
        </el-table-column>
        <el-table-column
            :fixed="$mq === 'xs' ? false : 'right'"
            align="center">
          <template slot-scope="scope">
            <el-button @click="deleteApproval(scope.row)" icon="el-icon-delete" type="danger" size="small"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
    props: ['selectedUpdate'],
    mounted() {
        this.getApprovalInventory();
        this.pullApprovals();
        this.$store.dispatch('pullInventory');
    },
    computed: {
        ...mapFields([
            'user',
            'inventory',
            'users',
            'inventoryTypes'
        ]),

        ainventory() {
            return this.inventory.filter((l) => l.requires_approval);
        }
    },
    data() {
        return {
            reqVisible: false,
            iReqLoading: false,
            cReqLoading: false,
            iSearchList: [],
            cSearchList: [],
            lApp: null,
            pending: null,
            existing: null,
            preapp: {
                requestor_id: null,
                item_id: null
            }
        };
    },
    methods: {
        getApprovalInventory() {
            this.axios.get('/api/v1/inventory/approvals/prestage/items',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.lApp = response.data;
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: 'Unable to prestage inventory approval.',
                    type: 'error'
                });
            });
        },
        cRemoteMethod(query) {
            if (query !== '') {
                this.cReqLoading = true;
                setTimeout(() => {
                    this.cReqLoading = false;
                    this.cSearchList = this.users.filter((item) => {
                        return this.getFullName(item).toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.cSearchList = this.users;
            }
        },
        iremoteMethod(query) {
            if (query !== '') {
                this.iReqLoading = true;
                setTimeout(() => {
                    this.iReqLoading = false;
                    this.iSearchList = this.lApp.filter((item) => {
                        return item.item_name.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.iSearchList = this.lApp;
            }
        },
        preapprove(){
            this.reqVisible = false;
            this.axios.post('/api/v1/inventory/approvals/prestage',
                JSON.stringify(this.preapp),
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.existing.push(response.data);
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });

        },
        approveApproval(row){
            this.axios.post('/api/v1/inventory/approvals/approve',
                {'pending_approval_id': row.o_id},
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                var temp = this.pending.find((objv) => objv.o_id == row.o_id);
                var index = this.pending.indexOf(temp);
                this.pending.splice(index, 1);
                this.existing.push(response.data);
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        },
        dismissApproval(row){
            this.axios.delete('/api/v1/inventory/request/'+row.request.o_id,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                var temp = this.pending.find((objv) => objv.o_id == row.o_id);
                var index = this.pending.indexOf(temp);
                this.pending.splice(index, 1);
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        },
        deleteApproval(row){
            this.axios.delete('/api/v1/inventory/approvals',
                {
                    params: {'o_id': row.o_id},
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                var temp = this.existing.find((objv) => objv.o_id == row.o_id);
                var index = this.existing.indexOf(temp);
                this.existing.splice(index, 1);
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        },
        pullApprovals(){
            this.axios.get('/api/v1/inventory/approvals/mypending',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.pending = response.data;
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
            this.axios.get('/api/v1/inventory/approvals/approved',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.existing = response.data;
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        }
    }
}
</script>
